import agentApply from './agentApply';
import agented from './agented';
import agentQueryFn from './agentQueryFn';
import cancelAgent from './cancelAgent';
import createAgent from './createAgent';
import handleRecordAgent from './handleRecordAgent';
export default {
    agentApply,
    agented,
    agentQueryFn,
    cancelAgent,
    createAgent,
    handleRecordAgent,
};


// WEBPACK FOOTER //
// ./src/api/agentQuery/index.ts